import { jsx as _jsx } from "react/jsx-runtime";
const MAP = {
    active: 'bg-emerald-100 text-emerald-700',
    trialing: 'bg-sky-100 text-sky-700',
    past_due: 'bg-amber-100 text-amber-800',
    canceled: 'bg-zinc-200 text-zinc-600',
    paid: 'bg-emerald-100 text-emerald-700',
    free: 'bg-zinc-200 text-zinc-600',
};
export function StatusPill({ value }) {
    const v = (value ?? '—').toLowerCase();
    const cls = MAP[v] ?? 'bg-zinc-200 text-zinc-600';
    return _jsx("span", { className: `inline-flex items-center rounded-full px-2 py-0.5 text-[12px] font-medium ${cls}`, children: value ?? '—' });
}
